export default __webpack_public_path__ + "static/media/m2_tstAnls.745ef6da.png";